import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { tuiArrayToggle } from '@taiga-ui/cdk';
import { tuiAsDataListHost, TuiDataList, TuiDataListHost, TuiLink, TuiScrollbar } from '@taiga-ui/core';
import { TuiMultiSelect } from '@taiga-ui/kit';
import { ListItem } from 'src/app/shared/models/helpers/list-item';
import { ScrollTrackerDirective } from '../directives/scroll-tracker.directive';

@Component({
  selector: 'pxc-list-picker',
  templateUrl: './list-picker.component.html',
  styleUrl: './list-picker.component.scss',
  imports: [
    TuiScrollbar,
    TuiDataList,
    TuiMultiSelect,
    FormsModule,
    TuiLink,
    ScrollTrackerDirective,
    TranslocoDirective,
  ],
  host: {
    class: 'flex flex-col items-stretch',
  },
  providers: [tuiAsDataListHost(ListPickerComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListPickerComponent implements TuiDataListHost<number> {
  @Input() items: ListItem[];
  @Input() disabledItems: number[] = [];
  @Input() emptyMessage: string;
  @Input() selection: number[] = [];
  @Input() disabled: boolean;

  @Output() selectionChange = new EventEmitter<number[]>();
  @Output() loadNextPage = new EventEmitter<void>();

  handleOption(value: number): void {
    this.selectionChange.emit(tuiArrayToggle(this.selection, value));
  }

  toggleAll(): void {
    if (this.items.length === this.selection.length) {
      // uncheck
      // keep only checked & disabled items
      this.selectionChange.emit(
        this.selection.filter((item) => this.selection.includes(item) && this.disabledItems.includes(item)),
      );
    } else {
      // check
      // everything that is not disabled (while keeping already selected items that could be disabled)
      this.selectionChange.emit([
        ...new Set([
          ...this.selection,
          ...this.items.filter((item) => !this.disabledItems.includes(item.value)).map((item) => item.value),
        ]),
      ]);
    }
  }
}
